<!--  Created by   : Namit Tiwari                                                             -->
<!--  Create Dated : 12-Mar-2021                                                              -->
<!--  Purpose      : Application Form Summary                                                 -->
<template>
  <div id="divSummary">
    <div class="Flex_Table">
      <div class="Flex_Row">
        <div class="Flex_Cell" style="width:30%">
          <span class="mandatorySpan" :class="{ Required: true }"
            >Advertisement For</span
          >
          <select id="ddlAdvertisment" v-model="advtID">
            <option value="-1">---Select---</option>
            <option v-for="c in advt_List" :key="c[0]" v-bind:value="c[0]">{{
              c[1]
            }}</option>
          </select>
        </div>
        <div class="Flex_Cell_Inline" valign="bottom">
          <label>
            <input type="checkbox" v-model="withDates" id="chkdates" />
            <label for="chkdates">Dates Filter</label>
          </label>
        </div>
        <div class="Flex_Cell_Inline" style="padding:none;">
          <transition name="fade">
            <div class="Flex_Table" v-if="withDates">
              <div class="Flex_Row">
                <div class="Flex_Cell_Inline">
                  <span class="mandatorySpan" :class="{ Required: true }"
                    >Date From</span
                  >
                  <DateControl
                    :isRequired="true"
                    v-model="fromDate"
                    :showDate="true"
                    title="Enter From Date"
                  >
                  </DateControl>
                </div>
                <div class="Flex_Cell_Inline">
                  <span class="mandatorySpan" :class="{ Required: true }"
                    >Date To</span
                  >
                  <DateControl
                    :isRequired="true"
                    v-model="toDate"
                    :showDate="true"
                    title="Enter To Date"
                  >
                  </DateControl>
                </div>
              </div>
            </div>
          </transition>
        </div>
        <div class="Flex_Cell" valign="bottom">
          <input
            type="button"
            v-on:click="getStatusSummary()"
            value="Get Status"
            style="padding: 5px"
            title="Click to Get Status Summary"
          />
          <input
            v-if="statusSummary_List.length > 0"
            type="button"
            id="btnGet"
            value="Export"
            v-on:click="SummaryReport()"
            style="padding: 5px 10px ;"
          />
        </div>
        <div class="Flex_Cell" align="right">
          <span style="text-align:right;color: #8a0000; font-weight: bold">* Fields are mandatory </span>
        </div>
      </div>
      <div class="Flex_Row">
        <div class="Flex_Cell">
          <div class="Flex_Table ekkGrid" style="border-radius: 6px;">
            <div
              class="Flex_Row GridHeader"
              valign="middle"
              style="min-height: 35px;"
            >
              <div class="Flex_Cell">Post Type</div>
              <div
                class="Flex_Cell"
                align="center"
                valign="middle"
                style="width:6%;"
              >
                Pending
              </div>
              <div
                class="Flex_Cell"
                align="center"
                valign="middle"
                style="width:6%;"
              >
                Total
              </div>
              <div
                class="Flex_Cell"
                align="center"
                valign="middle"
                style="width:6%;"
              >
                Rejected
              </div>
              <div
                class="Flex_Cell"
                align="center"
                valign="middle"
                style="width:6%;"
              >
                Accepted
              </div>
              <div
                class="Flex_Cell"
                align="center"
                valign="middle"
                style="width:6%;"
              >
                Sync
              </div>
              <div
                class="Flex_Cell"
                align="center"
                valign="middle"
                style="width:6%;"
              >
                UR
              </div>
              <div
                class="Flex_Cell"
                align="center"
                valign="middle"
                style="width:6%;"
              >
                SC
              </div>
              <div
                class="Flex_Cell"
                align="center"
                valign="middle"
                style="width:6%;"
              >
                ST
              </div>
              <div
                class="Flex_Cell"
                align="center"
                valign="middle"
                style="width:6%;"
              >
                OBC
              </div>
              <div
                class="Flex_Cell"
                align="center"
                valign="middle"
                style="width:6%;"
              >
                EWS
              </div>
              <div
                class="Flex_Cell"
                align="center"
                valign="middle"
                style="width:6%;"
              >
                PwBD
              </div>
              <div
                class="Flex_Cell"
                align="center"
                valign="middle"
                style="width:6%;"
              >
                ESM
              </div>
              <div
                class="Flex_Cell"
                align="center"
                valign="middle"
                style="width:6%;"
              >
                MSP
              </div>
            </div>
            <div class="GridContent" style="height:calc(100vh - 210px);">
              <div
                class="Flex_Row "
                style="min-height: 35px;"
                :class="[summary[0] === '-1' ? 'GridHeader' : '']"
                v-for="summary in statusSummary_List"
                :key="summary[0]"
              >
                <div class="Flex_Cell" valign="middle">
                  <span v-if="summary[0] != '-1'" style="font-size:medium;">{{
                    summary[1]
                  }}</span>
                  <span v-else>{{ summary[1] }}</span>
                </div>
                <div
                  class="Flex_Cell"
                  align="center"
                  valign="middle"
                  style="width:6%;"
                >
                  <input
                    v-if="summary[2] != ''"
                    type="button"
                    v-on:click="showCountPopUp(summary, 11)"
                    :value="summary[2]"
                    style="padding: 5px;width:100%"
                    title="Click to Get State wise Count"
                  />
                </div>
                <div
                  class="Flex_Cell"
                  align="center"
                  valign="middle"
                  style="width:6%;"
                >
                  <input
                    v-if="summary[3] != ''"
                    type="button"
                    v-on:click="showCountPopUp(summary, 12)"
                    :value="summary[3]"
                    style="padding: 5px;width:100%"
                    title="Click to Get State wise Count"
                  />
                </div>
                <div
                  class="Flex_Cell"
                  align="center"
                  valign="middle"
                  style="width:6%;"
                >
                  <input
                    v-if="summary[4] != ''"
                    type="button"
                    v-on:click="showCountPopUp(summary, 13)"
                    :value="summary[4]"
                    style="padding: 5px;width:100%"
                    title="Click to Get State wise Count"
                  />
                </div>
                <div
                  class="Flex_Cell"
                  align="center"
                  valign="middle"
                  style="width:6%;"
                >
                  <input
                    v-if="summary[5] != ''"
                    type="button"
                    v-on:click="showCountPopUp(summary, 14)"
                    :value="summary[5]"
                    style="padding: 5px;width:100%"
                    title="Click to Get State wise Count"
                  />
                </div>
                <div
                  class="Flex_Cell"
                  align="center"
                  valign="middle"
                  style="width:6%;"
                >
                  <input
                    v-if="summary[15] != ''"
                    type="button"
                    v-on:click="showCountPopUp(summary, 23)"
                    :value="summary[15]"
                    style="padding: 5px;width:100%"
                    title="Click to Get State wise Count"
                  />
                </div>
                <div
                  class="Flex_Cell"
                  align="center"
                  valign="middle"
                  style="width:6%;"
                >
                  <input
                    v-if="summary[6] != ''"
                    type="button"
                    v-on:click="showCountPopUp(summary, 15)"
                    :value="summary[6]"
                    style="padding: 5px;width:100%"
                    title="Click to Get State wise Count"
                  />
                </div>
                <div
                  class="Flex_Cell"
                  align="center"
                  valign="middle"
                  style="width:6%;"
                >
                  <input
                    v-if="summary[7] != ''"
                    type="button"
                    v-on:click="showCountPopUp(summary, 16)"
                    :value="summary[7]"
                    style="padding: 5px;width:100%"
                    title="Click to Get State wise Count"
                  />
                </div>
                <div
                  class="Flex_Cell"
                  align="center"
                  valign="middle"
                  style="width:6%;"
                >
                  <input
                    v-if="summary[8] != ''"
                    type="button"
                    v-on:click="showCountPopUp(summary, 17)"
                    :value="summary[8]"
                    style="padding: 5px;width:100%"
                    title="Click to Get State wise Count"
                  />
                </div>
                <div
                  class="Flex_Cell"
                  align="center"
                  valign="middle"
                  style="width:6%;"
                >
                  <input
                    v-if="summary[9] != ''"
                    type="button"
                    v-on:click="showCountPopUp(summary, 18)"
                    :value="summary[9]"
                    style="padding: 5px;width:100%"
                    title="Click to Get State wise Count"
                  />
                </div>
                <div
                  class="Flex_Cell"
                  align="center"
                  valign="middle"
                  style="width:6%;"
                >
                  <input
                    v-if="summary[13] != ''"
                    type="button"
                    v-on:click="showCountPopUp(summary, 22)"
                    :value="summary[13]"
                    style="padding: 5px;width:100%"
                    title="Click to Get State wise Count"
                  />
                </div>
                <div
                  class="Flex_Cell"
                  align="center"
                  valign="middle"
                  style="width:6%;"
                >
                  <input
                    v-if="summary[10] != ''"
                    type="button"
                    v-on:click="showCountPopUp(summary, 19)"
                    :value="summary[10]"
                    style="padding: 5px;width:100%"
                    title="Click to Get State wise Count"
                  />
                </div>
                <div
                  class="Flex_Cell"
                  align="center"
                  valign="middle"
                  style="width:6%;"
                >
                  <input
                    v-if="summary[11] != ''"
                    type="button"
                    v-on:click="showCountPopUp(summary, 20)"
                    :value="summary[11]"
                    style="padding: 5px;width:100%"
                    title="Click to Get State wise Count"
                  />
                </div>
                <div
                  class="Flex_Cell"
                  align="center"
                  valign="middle"
                  style="width:6%;"
                >
                  <input
                    v-if="summary[12] != ''"
                    type="button"
                    v-on:click="showCountPopUp(summary, 21)"
                    :value="summary[12]"
                    style="padding: 5px;width:100%"
                    title="Click to Get State wise Count"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition name="popbounce">
      <div class="PopUpCover" v-if="showPopup">
        <div class="GridHeader PopUpHeader">
          <div class="Flex_Table">
            <div class="Flex_Row">
              <div class="Flex_Cell_Inline" align="center" valign="middle">
                <span id="spnRateHead" style="font-weight: bold">{{
                  popHeader
                }}</span>
              </div>
              <div class="Flex_Cell_Inline">
                <input
                  v-if="statusDetail_List.length > 0"
                  type="button"
                  id="btnGet"
                  value="Export"
                  v-on:click="SummaryDetailReport()"
                />
              </div>
              <div class="Flex_Cell_Inline" style="width: 25px">
                <a class="PopClose" v-on:click="onHidePopUp()" title="close"
                  >X</a
                >
              </div>
            </div>
          </div>
        </div>
        <div class="PopUpDetail">
          <div class="Flex_Table ekkGrid" style="border-radius: 6px;">
            <div
              class="Flex_Row GridHeader myhead"
              style="min-height: 35px;overflow-y: scroll"
            >
              <div
                class="Flex_Cell"
                style="width:10%"
                align="center"
                valign="middle"
              >
                SrNo
              </div>
              <div class="Flex_Cell" valign="middle">State</div>
              <div
                class="Flex_Cell"
                style="width:15%"
                align="center"
                valign="middle"
              >
                Count
              </div>
            </div>
            <div
              class="GridContent"
              style="height: calc(100vh - 250px);overflow-y:scroll;"
            >
              <div
                class="Flex_Row"
                style="min-height: 35px;"
                v-for="(count, index) in statusDetail_List.filter(s => {
                  return s[0] != '-100';
                })"
                :key="count[0]"
              >
                <div
                  class="Flex_Cell"
                  style="width:10%"
                  align="center"
                  valign="middle"
                >
                  <span v-if="count[0] != '-100'">{{ index + 1 }} </span>
                </div>
                <div class="Flex_Cell" valign="middle">{{ count[1] }}</div>
                <div
                  class="Flex_Cell"
                  style="width:15%"
                  align="center"
                  valign="middle"
                >
                  {{ count[2] }}
                </div>
              </div>
            </div>
            <div
              class="Flex_Row GridHeader myhead"
              style="min-height: 35px;overflow-y: scroll"
              v-for="(count, index) in statusDetail_List.filter(s => {
                return s[0] == '-100';
              })"
              :key="count[0]"
            >
              <div
                class="Flex_Cell"
                style="width:10%"
                align="center"
                valign="middle"
              >
                <span v-if="count[0] != '-100'">{{ index + 1 }} </span>
              </div>
              <div class="Flex_Cell" valign="middle">{{ count[1] }}</div>
              <div
                class="Flex_Cell"
                style="width:15%"
                align="center"
                valign="middle"
              >
                {{ count[2] }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <div class="backgroundPopup" v-if="showBackGround"></div>
  </div>
</template>
<script>
import vue from "vue";
import Router from "vue-router";
import axios from "axios";
import config from "@/router/globalConfig";
import DateControl from "./ekkControls/DateControl";
import Report from "@/router/Report";
export default {
  name: "StatusSummary",
  components: {
    DateControl: DateControl
  },
  data() {
    return {
      showPopup: false,
      showBackGround: false,
      popHeader: "Pop Header Text Come",
      withDates: false,
      advtID: -1,
      advt_List: [],
      statusSummary_List: [],
      statusDetail_List: [],
      fromDate: new Date(),
      toDate: new Date(),
      popPostTypeID: -1,
      popType: 1
    };
  },
  methods: {
    getAdvertisment() {
      this.advt_List = [];
      const _data_ = { type: 1 };
      axios
        .get(config.WEB_API_PATH + "Master/GetAdvertisment", {
          headers: {
            __RequestVerificationToken: config.AF_Token,
            Authorization: config.LOG_Token
          },
          params: _data_,
          crossdomain: true
        })
        .then(
          response => {
            this.advt_List = response.data;
            if (response.data.length > 0) {
              this.advtID = response.data[0][0];
              this.fromDate = new Date(response.data[0][2]);
              this.getStatusSummary();
            }
          },
          error => {}
        );
    },
    getStatusSummary() {
      this.statusSummary_List = [];
      const _data_ = {
        advtID: this.advtID,
        postTypeID: -1,
        applicationFrom: this.fromDate.convertToString("dd MMM yyyy"),
        applicationTo: this.toDate.convertToString("dd MMM yyyy"),
        mainType: this.withDates ? 2 : 1,
        type: 1
      };
      axios
        .get(config.WEB_API_PATH + "StatusSummary/GetStatusSummary", {
          headers: {
            __RequestVerificationToken: config.AF_Token,
            Authorization: config.LOG_Token
          },
          params: _data_,
          crossdomain: true
        })
        .then(
          response => {
            this.statusSummary_List = response.data.result;
          },
          error => {}
        );
    },
    SummaryReport() {
      var advertName = "";
      this.advt_List.forEach(element => {
        if (element[0] == this.advtID) {
          advertName = element[1];
        }
      });
      var dates =
        this.fromDate.convertToString("dd MMM yyyy") +
        " - " +
        this.toDate.convertToString("dd MMM yyyy");
      var basicData = {
        CourseID: this.advtID,
        PostTypeID: -1,
        IsWithDate: this.IsWithDate,
        FromDate: this.fromDate.convertToString("dd MMM yyyy"),
        ToDate: this.toDate.convertToString("dd MMM yyyy"),
        MainType: this.withDates ? 2 : 1,
        Type: 1,
        FileName: "StatusSummaryReport",
        // FileFormat: this.exportToExcel == true ? "Excel" : "PDF",
        // FileExtension: this.exportToExcel == true ? "xls" : "pdf",
        FileFormat: "Excel",
        FileExtension: "xls",
        ReportType: 1,
        Param1: "Status Summary of :: " + advertName,
        Param2: this.withDates ? dates : ""
      };
      var formData = new FormData();
      formData.append("BasicFormData", JSON.stringify(basicData));
      axios
        .post(
          config.WEB_API_PATH + "StatusSummary/StatusSummaryReport",
          formData,
          {
            headers: {
              __RequestVerificationToken: config.AF_Token,
              Authorization: config.LOG_Token
            },
            crossdomain: true
          }
        )
        .then(
          response => {
            var msg = Report.showReport(response.data.result, false);
            if (msg == false) {
              MessageBox.show({
                message: "No Record Found",
                type: "error",
                title: "API says"
              });
            }
          },
          error => {}
        );
    },
    showCountPopUp(row, type) {
      this.popPostTypeID = row[0];
      this.popType = type;
      const _data_ = {
        advtID: this.advtID,
        postTypeID: row[0],
        applicationFrom: this.fromDate.convertToString("dd MMM yyyy"),
        applicationTo: this.toDate.convertToString("dd MMM yyyy"),
        mainType: this.withDates ? 2 : 1,
        type: type
      };
      axios
        .get(config.WEB_API_PATH + "StatusSummary/GetStatusSummary", {
          headers: {
            __RequestVerificationToken: config.AF_Token,
            Authorization: config.LOG_Token
          },
          params: _data_,
          crossdomain: true
        })
        .then(
          response => {
            this.statusDetail_List = response.data.result;
            if (response.data.result.length > 0) {
              this.popHeader = row[1];
              switch (type) {
                case 11:
                  this.popHeader = this.popHeader + " :: Pending Count";
                  break;
                case 12:
                  this.popHeader = this.popHeader + " :: Total Count";
                  break;
                case 13:
                  this.popHeader = this.popHeader + " :: Rejected Count";
                  break;
                case 14:
                  this.popHeader = this.popHeader + " :: Accepted Count";
                  break;
                case 15:
                  this.popHeader = this.popHeader + " :: UR Count";
                  break;
                case 16:
                  this.popHeader = this.popHeader + " :: SC Count";
                  break;
                case 17:
                  this.popHeader = this.popHeader + " :: ST Count";
                  break;
                case 18:
                  this.popHeader = this.popHeader + " :: OBC Count";
                  break;
                case 19:
                  this.popHeader = this.popHeader + " :: PwBD Count";
                  break;
                case 20:
                  this.popHeader = this.popHeader + " :: ESM Count";
                  break;
                case 21:
                  this.popHeader = this.popHeader + " :: MSP Count";
                  break;
                case 22:
                  this.popHeader = this.popHeader + " :: EWS Count";
                  break;
                case 23:
                  this.popHeader = this.popHeader + " :: Sync Count";
                  break;
                default:
                  this.popHeader = row[1];
                  break;
              }
              this.showPopup = true;
              this.showBackGround = true;
            } else {
              MessageBox.show({
                message: "No DATA Found",
                type: "info",
                title: "API says"
              });
            }
          },
          error => {}
        );
    },
    onHidePopUp() {
      this.showPopup = false;
      this.showBackGround = false;
    },
    SummaryDetailReport() {
      var advertName = "";
      this.advt_List.forEach(element => {
        if (element[0] == this.advtID) {
          advertName = element[1];
        }
      });
      var dates =
        this.fromDate.convertToString("dd MMM yyyy") +
        " - " +
        this.toDate.convertToString("dd MMM yyyy");
      var basicData = {
        CourseID: this.advtID,
        PostTypeID: this.popPostTypeID,
        IsWithDate: this.IsWithDate,
        FromDate: this.fromDate.convertToString("dd MMM yyyy"),
        ToDate: this.toDate.convertToString("dd MMM yyyy"),
        MainType: this.withDates ? 2 : 1,
        Type: this.popType,
        FileName: "DetailSummaryReport",
        // FileFormat: this.exportToExcel == true ? "Excel" : "PDF",
        // FileExtension: this.exportToExcel == true ? "xls" : "pdf",
        FileFormat: "Excel",
        FileExtension: "xls",
        ReportType: 2,
        Param1: "State Summary of :: " + advertName + " " + this.popHeader,
        Param2: this.withDates ? dates : ""
      };
      var formData = new FormData();
      formData.append("BasicFormData", JSON.stringify(basicData));
      axios
        .post(
          config.WEB_API_PATH + "StatusSummary/StatusSummaryReport",
          formData,
          {
            headers: {
              __RequestVerificationToken: config.AF_Token,
              Authorization: config.LOG_Token
            },
            crossdomain: true
          }
        )
        .then(
          response => {
            var msg = Report.showReport(response.data.result, false);
            if (msg == false) {
              MessageBox.show({
                message: "No Record Found",
                type: "error",
                title: "API says"
              });
            }
          },
          error => {}
        );
    }
  },
  computed: {},
  mounted() {
    this.getAdvertisment();
  },
  watch: {}
};
</script>
<style scoped>
.myhead::-webkit-scrollbar {
  background-color: transparent;
}
.myhead::scrollbar {
  background-color: transparent;
}
.mandatorySpan {
  text-align: left;
  position: relative;
  display: block;
  padding: 0;
  margin-bottom: 5px;
  font-weight: bold;
}
.mandatorySpan.Required:after {
  color: red;
  content: "*";
  position: absolute;
  height: 8px;
  top: -5px;
  font-size: 200%;
}
#divSummary {
  margin-left: 4px;
  margin-right: 5px;
  /* border: dotted 1px darkgray;
        border-radius: 5px;
        padding: 5px 0px 0px 5px; */
}
.ekkGrid > .Flex_Row:hover:not(.GridHeader),
.ekkGrid > .GridContent > .Flex_Row:hover:not(.GridHeader) {
  background-color: #ffa50069;
  color: black;
}
</style>
<style scoped>
.fade-enter-active {
  animation: fade-in 0.4s;
}
.fade-leave-active {
  animation: fade-in 0.4s reverse;
}
@keyframes fade-in {
  0% {
    opacity: 0;
  }
  5% {
    opacity: 0.05;
  }
  10% {
    opacity: 0.1;
  }
  20% {
    opacity: 0.2;
  }
  25% {
    opacity: 0.25;
  }
  30% {
    opacity: 0.3;
  }
  35% {
    opacity: 0.35;
  }
  40% {
    opacity: 0.4;
  }
  45% {
    opacity: 0.45;
  }
  50% {
    opacity: 0.5;
  }
  55% {
    opacity: 0.55;
  }
  60% {
    opacity: 0.6;
  }
  65% {
    opacity: 0.65;
  }
  70% {
    opacity: 0.7;
  }
  75% {
    opacity: 0.75;
  }
  80% {
    opacity: 0.8;
  }
  85% {
    opacity: 0.85;
  }
  90% {
    opacity: 0.9;
  }
  95% {
    opacity: 0.95;
  }
  100% {
    opacity: 1;
  }
}
</style>
<style scoped>
.backgroundPopup {
  position: fixed;
  _position: absolute; /* hack for internet explorer 6*/
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  background: #000000;
  border: 1px solid #cecece;
  z-index: 1;
  opacity: 0.5;
}
.PopUpCover {
  border: solid 1px;
  border-radius: 4px;
  top: 110px;
  position: absolute;
  min-height: 256px;
  right: 380px;
  /* background-color: ;rgba(255, 248, 248, 0.86); */
  background-color: ghostwhite;
  -webkit-box-shadow: 1px 1px 20px 1px white;
  box-shadow: 1px 1px 20px 1px white;
  border-radius: 8px 8px 8px 8px;
  z-index: 2;
  color: black !important;
  width: 600px;
}
.PopUpDetail {
  padding: 10px;
  /* min-height: 200px;
        max-height: 400px; */
  overflow: auto;
}
.PopUpHeader {
  padding: 5px !important;
  font-size: 13pt;
  min-height: 38px;
  border-bottom: solid 1px;
  border-radius: 8px;
}
.PopClose {
  line-height: 18px;
  right: 2px;
  top: 3px;
  position: absolute;
  color: white;
  font-weight: 700;
  display: block;
  padding: 5px;
  background-color: rgba(255, 0, 0, 0.94);
  border-radius: 6px;
  cursor: pointer;
  width: 28px;
  text-align: center;
}
.popbounce-enter-active {
  animation: popbounce-in 0.5s;
}
.popbounce-leave-active {
  animation: popbounce-in 0.4s reverse;
}
@keyframes popbounce-in {
  0% {
    transform: scale(0);
  }
  25% {
    transform: scale(0.25);
  }
  50% {
    transform: scale(0.5);
  }
  75% {
    transform: scale(0.75);
  }
  100% {
    transform: scale(1);
  }
}
</style>
<style scoped>
@media screen and (max-width: 800px) {
  .EntryBlock {
    width: 80%;
  }
  #divApplication {
    display: block;
    height: auto;
  }
  #location {
    width: 70%;
  }
  .PopUpCover {
    right: 0px !important;
    left: 18px !important;
  }
  .EntryBlock {
    width: 100%;
  }
  fieldset > div {
    width: calc(100vw - 15px);
    overflow: auto;
  }
  .tblEntryForm {
    width: calc(100vw - 35px);
  } /* width 15px less*/
  .tblEntryForm .Flex_Row {
    display: flex;
    flex-wrap: wrap;
  } /* this is responsible for cell wraping*/
  .tblEntryForm .Flex_Row > .Flex_Cell {
    width: 50% !important;
  } /* width of any cell time of screen sizing*/
  .tblEntryForm .Flex_Row > .Flex_Cell_Inline {
    width: 50% !important;
    line-height: 36px;
  } /* width of any cell time of screen sizing*/
  /* Auto calculate the height of the grid div for scrolling when screen size change*/
  .Location {
    max-width: calc(100vw - 30px) !important;
    width: calc(100vw - 40px) !important;
  }
  /*Overflow for horizontal */
  .ekkGrid .GridContent {
    overflow: unset;
  }
  /*then only horizontal scrolling works */
  .Flex_Table.ekkGrid .Flex_Row {
    width: 100%;
  }
}
@media screen and (max-width: 480px) {
  .EntryBlock {
    width: calc(100vw - 35px);
  }
  fieldset > div {
    width: calc(100vw - 35px);
    overflow: auto;
  }
  #location {
    width: 70%;
  }
  .PopUpCover {
    right: 0px !important;
    left: 18px !important;
  }
  .tblEntryForm > .Flex_Row > .Flex_Cell {
    width: 100% !important;
  }
  .tblEntryForm > .Flex_Row > .Flex_Cell_Inline {
    width: 100% !important;
    line-height: 36px;
  }
  .tblEntryForm .divHR {
    display: block;
  }
  .Flex_Table.ekkGrid.Location {
    max-width: calc(100vw - 40px) !important;
    width: calc(100vw - 40px) !important;
  }
  legend {
    width: calc(100vw - 40px) !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/StatusSummary.vue